import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const LogisticsDeliveryAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.logistics} />

export default LogisticsDeliveryAppDevelopment
